import React from "react";

/**
 * @component ArrowUpIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <ArrowUpIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ArrowUpIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-testid="ArrowUpIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M15.372 14.236a.993.993 0 001.349 0 .867.867 0 000-1.275L12 8.5l-4.72 4.461a.867.867 0 000 1.275.993.993 0 001.348 0L12 11.049l3.372 3.187z"
      />
    </svg>
  )
);
ArrowUpIcon.displayName = "ArrowUpIcon";
export default ArrowUpIcon;
